



import {Component, Vue} from 'vue-property-decorator'
import ServicesInfo from '@/components/services/ServicesInfo.vue'

@Component({
    components: {
        ServicesInfo,
    },
})
export default class Services extends Vue {}
